import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { fontWeights, colors } from '@/styles'
import ModalBase from '@/components/modal/modal-base'
import Context from '@/components/modal/context'
import RightArrowIcon from './right-arrow.svg'
import { show as showSelectApplicantModal } from './select-applicant-modal'
import { show as showSelectRecipientFormModal } from './add-recipient-form-modal'

const Wrapper = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  > :first-child {
    margin-bottom: 24px;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 16px;
  width: 100%;
`
const ButtonTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const ButtonTitle = styled.p`
  font-weight: ${fontWeights.bold};
  font-size: 16px;
  line-height: 20px;
  margin: 0 16px 10px 0;
`

const ButtonText = styled.p`
  font-weight: ${fontWeights.regular};
  font-size: 14px;
  line-height: 16px;
  color: ${colors.grey56};
  margin: 0;
`

const StyledIcon = styled.img`
  margin-bottom: 10px;
`

const AddRecipientModal = ({
  contractId,
  ModalTitle,
  signees,
  setSignees,
  fileMetadata,
  setFileMetadata,
  currentUser,
  setUser
}) => {
  const { t } = useTranslation()
  const { close } = useModalize()

  const handleShowApplicantModal = () => {
    close()
    showSelectApplicantModal({
      contractId,
      signees,
      setSignees,
      fileMetadata,
      setFileMetadata,
      currentUser,
      setUser
    })
  }

  const handleShowRecipientFormModal = () => {
    close()
    showSelectRecipientFormModal({
      contractId,
      signees,
      setSignees,
      fileMetadata,
      setFileMetadata,
      currentUser,
      setUser
    })
  }

  return (
    <Context.Provider
      value={{
        ModalTitle,
        close
      }}
    >
      <ModalBase
        overflow="visible"
        minHeight={295}
        title={t('l.contract.create.add_recipient_from.title', 'Add recipient from...')}
      >
        <Wrapper>
          <Button
            type="button"
            theme="secondary"
            onClick={handleShowApplicantModal}
            size="medium"
            width="100%"
            space="fit"
          >
            <ButtonWrapper>
              <ButtonTitleWrapper>
                <ButtonTitle>
                  {t('l.contract.create.application_list.text', 'Application list')}
                </ButtonTitle>
                <StyledIcon src={RightArrowIcon} />
              </ButtonTitleWrapper>
              <ButtonText>
                {t(
                  'l.contract.create.select_from_your_applicants.text',
                  'Select from your list of applicants in liv.rent.'
                )}
              </ButtonText>
            </ButtonWrapper>
          </Button>

          <Button
            type="button"
            theme="secondary"
            onClick={handleShowRecipientFormModal}
            size="medium"
            width="100%"
            space="fit"
          >
            <ButtonWrapper>
              <ButtonTitleWrapper>
                <ButtonTitle>
                  {t('l.contract.create.add_new_recipient.text', 'Add new recipient')}
                </ButtonTitle>
                <StyledIcon src={RightArrowIcon} />
              </ButtonTitleWrapper>
              <ButtonText>
                {t(
                  'l.contract.create.found_your_tenant_outside_of_liv_rent.text',
                  'Found your tenant outside of liv.rent? Add them as a recipient here.'
                )}
              </ButtonText>
            </ButtonWrapper>
          </Button>
        </Wrapper>
      </ModalBase>
    </Context.Provider>
  )
}

export const show = createModal(AddRecipientModal, {
  width: '640px',
  sheet: true
})
